














import { Component, Vue, Prop } from "vue-property-decorator";
import { Profit } from "@foxone/api/src/models/hfox";

@Component
class RorChart extends Vue {
  @Prop() profits!: Profit[];

  roryAxis = {
    splitLine: {
      show: false
    },
    axisTick: {
      show: false
    }
  };

  rorxAxis = {
    splitLine: {
      show: false
    }
  };

  get rorProfits() {
    const chartData = {
      columns: [] as string[],
      rows: [] as any[]
    };
    if (this.profits.length !== 0) {
      this.profits.forEach(e => {
        const chartValue = {} as any;
        chartValue.date = this.$common.utils.date.formatDate(e.date, "MM/DD");
        chartValue.rate = Number.parseFloat(e.rate);
        chartData.rows.push(chartValue);
      });
      chartData.columns = ["date", "rate"];
    }
    return chartData;
  }

  get rateChartSettings() {
    return {
      area: true,
      labelMap: {
        rate: this.$t("common.ror")
      },
      yAxisType: ["percent"],
      metrics: ["rate"],
      dimension: ["date"]
    };
  }

  get areaColors() {
    return this.$store.state.app.settings.dark
      ? ["#c18c7d", "#4b3833"]
      : ["#fdf0ec", "#f9ccc0"];
  }

  get rateOptions() {
    const areaColors = this.areaColors;
    return {
      color: ["#ffb931"],
      yAxis: {
        splitNumber: 3,
        axisLabel: {
          formatter: v => {
            return `${(v * 100).toFixed(0)}%`;
          },
          fontSize: 12,
          color: "#999999",
          inside: true
        }
      },
      xAxis: {
        axisTick: {
          show: false
        },
        axisLabel: {
          fontSize: 12,
          color: "#999999"
        }
      },
      series: {
        name: this.$t("common.ror"),
        type: "line",
        lineStyle: {
          width: 2,
          type: "solid",
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#ea532a"
              },
              {
                offset: 1,
                color: "#ffb931"
              }
            ],
            global: false
          }
        },
        showSymbol: false,
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: areaColors[0]
              },
              {
                offset: 1,
                color: areaColors[1]
              }
            ],
            global: false
          }
        }
      }
    };
  }
}
export default RorChart;
